import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { useDropzone } from "react-dropzone";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
// import Alert from "@mui/material/Alert";
import DropzoneComponent from "./DropzoneComponent"; // Import the custom Dropzone
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const QualityReportsAddPallet = () => {
  let { id } = useParams();

  // const [ordersLists, setOrdersLists] = useState([]);
  const [palletlist, setPlletlist] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  // IMAGE HANDLING STATES
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  const [showCropper, setShowCropper] = useState(false);


  useEffect(() => {
        setPermission(FindModuleById(447)); 
console.log(permission);



    axios
      .get(`/quality-report/add-pallet/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
           setValue(response.data.data.report);
           let pallet =  response.data.data.report.pallet;
           if (pallet && Object.keys(pallet).length > 0) {
            // Populate with existing pallet data
            let existingPallet = {
              product: pallet.product,
              temperature: pallet.temperature,
              size: pallet.size,
              sample_weight: pallet.sample_weight,
              class: pallet.class,
              box_net_weight: pallet.box_net_weight,
              packaging: pallet.packaging,
              lot_number: pallet.lot_number,
              number_of_boxes: pallet.number_of_boxes,
              palletesation: pallet.palletesation, // Ensure consistent spelling
              country: pallet.country,
              label_conformity: pallet.label_conformity,
              pictures: [], // If pictures need to be populated, do so here
            };
            setPlletlist([existingPallet]);
          } else {
            // Set default pallet data
            let newPallet = {
              product: "",
              temperature: "",
              size: "",
              sample_weight: "",
              class: "",
              box_net_weight: "",
              packaging: "",
              lot_number: "",
              number_of_boxes: "",
              palletesation: "",
              country: "Morocco", // Default value
              label_conformity: "",
              pictures: [], // Empty array as a placeholder
            };
            setPlletlist([newPallet]);
          }
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

console.log(backendErrors);


  const formik = useFormik({
    initialValues: {
      id: id,
      pallets: palletlist,
      // pallets: [
      //   {
      //     product: "",
      //     temperature: "",
      //     size: "",
      //     sample_weight: "",
      //     class: "",
      //     box_net_weight: "",
      //     packaging: "",
      //     lot_number: "",
      //     number_of_boxes: "",
      //     palletesation: "",
      //     country: "Morocco",
      //     label_conformity: "",
      //     pictures: [],
      //   },
      // ],
  
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
    //  console.log("Form submitted with values: ", values); // Check if form submission triggers

      axios
        .post("/quality-report/update-pallet", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Pallets");
          if (response.data.code === 200) {
            setSubmitting(false);
            toast.success(response.data.message);
            //setBackendSuccess(response.data.message);
            setTimeout(() => {
              window.location.href = "/quality-reports";
            }, 500);
          } else {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    },
  });



 
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Converts file to Base64
      reader.onload = () => resolve(reader.result); // Base64 string
      reader.onerror = (error) => reject(error);
    });
  };

const onDrop = useCallback(
  async (acceptedFiles, palletIndex) => {
    const filesArray = Array.from(acceptedFiles);
    const currentPictures = formik.values.pallets[palletIndex]?.pictures || [];

    try {
      const resizedImages = await Promise.all(
        filesArray.map(async (file) => {
          const base64Image = await fileToBase64(file);
          return resizeImage(base64Image, 1200, 1200); // Resize to 65mm x 65mm (approx. 246px x 246px)
        })
      );

      let updatedPictures = [...currentPictures, ...resizedImages];
      if (updatedPictures.length > 6) {
        updatedPictures.length = 6;
      }

      formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

      setImages((prevImages) => {
        const newImages = Array.isArray(prevImages) ? [...prevImages] : [];
        newImages[palletIndex] = updatedPictures;
        return newImages;
      });
    } catch (error) {
      console.error("Error resizing images:", error);
    }
  },
  [formik]
);
  // const getDropzoneProps = (palletIndex) => {
  //   return useDropzone({
  //     accept: "image/*",
  //     multiple: true,
  //     onDrop: (acceptedFiles) => onDrop(acceptedFiles, palletIndex),
  //   });
  // };

const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels);
}, []);

const resizeImage = (base64Str, maxWidth, maxHeight) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = maxWidth;
      canvas.height = maxHeight;
      ctx.drawImage(img, 0, 0, maxWidth, maxHeight);
      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
};
  


const getCroppedImage = async (imageSrc) => {
  const image = new Image();
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas size to the cropped area resolution
      const scaleX = image.naturalWidth / image.width; // Adjust for potential scaling
      const scaleY = image.naturalHeight / image.height;

      const croppedWidth = croppedAreaPixels.width * scaleX;
      const croppedHeight = croppedAreaPixels.height * scaleY;

      canvas.width = croppedWidth;
      canvas.height = croppedHeight;

      // Apply rotation and cropping
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        image,
        croppedAreaPixels.x * scaleX,
        croppedAreaPixels.y * scaleY,
        croppedWidth,
        croppedHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      // Export as a high-quality image
      const base64Image = canvas.toDataURL("image/jpeg", 1.0); // 95% quality
      resolve(base64Image);
    };

    image.onerror = (err) => reject(err);
  });
};


// const getCroppedImage12 = async (imageSrc) => {
//   const image = new Image();
//   image.src = imageSrc;

//   return new Promise((resolve, reject) => {
//     image.onload = () => {
//       const canvas = document.createElement("canvas");
//       const ctx = canvas.getContext("2d");

//       canvas.width = croppedAreaPixels.width;
//       canvas.height = croppedAreaPixels.height;

//       ctx.translate(canvas.width / 2, canvas.height / 2);
//       ctx.rotate((rotation * Math.PI) / 180);
//       ctx.translate(-canvas.width / 2, -canvas.height / 2);

//       ctx.drawImage(
//         image,
//         croppedAreaPixels.x,
//         croppedAreaPixels.y,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height,
//         0,
//         0,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height
//       );

//       const base64Image = canvas.toDataURL("image/jpeg");
//       resolve(base64Image);
//     };
//     image.onerror = (err) => reject(err);
//   });
// };


  
const handleSaveCroppedImage = async (palletIndex, imgIndex) => {
 // setLoading(true);
  try {
    const croppedImageUrl = await getCroppedImage(
      images[palletIndex][imgIndex]
    );
    const updatedImages = [...formik.values.pallets[palletIndex].pictures];
    updatedImages[imgIndex] = croppedImageUrl;
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);

    // setImages((prev) => ({
    //   ...prev,
    //   [palletIndex]: updatedImages,
    // }));
    setImages((prevImages) => {
      const newImages = [...prevImages]; // Create a shallow copy of the outer array
      newImages[palletIndex] = [...newImages[palletIndex]]; // Create a shallow copy of the specific pallet's images
      newImages[palletIndex][imgIndex] = croppedImageUrl; // Update the specific image
      return newImages; // Return the updated array
    });
  } catch (error) {
    console.error("Error saving cropped image:", error);
  } finally {
    //setLoading(false);
  }

  setShowCropper(false);
};
  
      
    // const handleDeleteImage12 = (palletIndex, imgIndex) => {

    //     let  imgg =  formik.values.pallets[palletIndex]?.pictures[imgIndex]
    //     if (imgg) {
    //       // Use URL constructor to parse the URL
    //       const parsedUrl = new URL(imgg);
      
    //       // Extract the pathname from the URL
    //       const imagePath = parsedUrl.pathname; // "/qualityreports-pallets-images/41dac4e6-165f-4bd7-b415-473a15b94d6f.jpeg"
          
    //       // Remove the leading '/'
    //     // const finalImagePath = imagePath.substring(1); // "qualityreports-pallets-images/41dac4e6-165f-4bd7-b415-473a15b94d6f.jpeg"
    //       const finalImagePath = imagePath.substring(1).replace(/\//g, '--'); // "qualityreports-pallets-images/41dac4e6-165f-4bd7-b415-473a15b94d6f.jpeg" => "qualityreports--pallets--images--41dac4e6-165f-4bd7-b415-473a15b94d6f.jpeg"

    //       // If finalImagePath exists, call deletepalletImagefromDB
    //       if (finalImagePath) {
    //         deletepalletImagefromDB(finalImagePath);
    //       }
    //     }
    //       const currentPictures = formik.values.pallets[palletIndex]?.pictures || [];
    //       const updatedPictures = currentPictures.filter((_, i) => i !== imgIndex);
    //       formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

    //       setImages((prev) => ({
    //         ...prev,
    //         [palletIndex]: updatedPictures,
    //       }));

    //       if (imgIndex === currentImageIndex) {
    //         setCurrentImageIndex(Math.max(0, imgIndex - 1));
    //       }
    // };

      // const handleDeleteImage121 = (palletIndex, imgIndex) => {
      //   // Get a deep copy of the current state of pallets' pictures
      //   const updatedPallets = [...formik.values.pallets];

      //   // Ensure that we're working on a copy of the specific pallet's pictures array
      //   const currentPictures = [...(updatedPallets[palletIndex]?.pictures || [])];

      //   // Remove the image at the specified index
      //   if (currentPictures.length > imgIndex) {
      //     currentPictures.splice(imgIndex, 1); // Remove the image at imgIndex
      //   }

      //   // Update the specific pallet's pictures in the deep copy of the formik state
      //   updatedPallets[palletIndex].pictures = currentPictures;

      //   // Update formik's state with the modified copy
      //   formik.setFieldValue(`pallets`, updatedPallets);

      //   // Update the images state to reflect the change locally (for rendering)
      //   setImages((prevImages) => {
      //     const newImages = [...prevImages];
      //     newImages[palletIndex] = currentPictures;
      //     return newImages;
      //   });

      //   // Update currentImageIndex if necessary to prevent out-of-bounds issues
      //   if (imgIndex === currentImageIndex) {
      //     setCurrentImageIndex(Math.max(0, imgIndex - 1));
      //   }
      // };

      const handleDeleteImage = (palletIndex, imgIndex) => {
        // Get a deep copy of the current state of pallets' pictures
        const updatedPallets = [...formik.values.pallets];
      
        // Ensure that we're working on a copy of the specific pallet's pictures array
        const currentPictures = [...(updatedPallets[palletIndex]?.pictures || [])];
      
        // Check if the image exists at the specified index and if it is a URL
        const imageToDelete = currentPictures[imgIndex];
        if (imageToDelete && imageToDelete.startsWith('http')) {
          // Extract and format the image path from the URL
          try {
            const parsedUrl = new URL(imageToDelete);
            const imagePath = parsedUrl.pathname.substring(1).replace(/\//g, '--'); // Convert path separators for the endpoint format
      
            // Call the function to delete the image from the database
            deletepalletImagefromDB(imagePath)
              .then((response) => {
                if (response.status === 'ok') {
                  console.log('Image deleted successfully from database');
                } else {
                  console.error('Failed to delete the image from database');
                }
              })
              .catch((error) => {
                console.error('Error deleting image from database:', error);
              });
          } catch (error) {
            console.error('Error parsing image URL:', error);
          }
        }
      
        // Remove the image from the local state
        if (currentPictures.length > imgIndex) {
          currentPictures.splice(imgIndex, 1); // Remove the image at imgIndex
        }
      
        // Update the specific pallet's pictures in the deep copy of the formik state
        updatedPallets[palletIndex].pictures = currentPictures;
      
        // Update formik's state with the modified copy
        formik.setFieldValue(`pallets`, updatedPallets);
      
        // Update the images state to reflect the change locally (for rendering)
        setImages((prevImages) => {
          const newImages = [...prevImages];
          newImages[palletIndex] = currentPictures;
          return newImages;
        });
      
        // Update currentImageIndex if necessary to prevent out-of-bounds issues
        if (imgIndex === currentImageIndex) {
          setCurrentImageIndex(Math.max(0, imgIndex - 1));
        }
      };
      
const deletepalletImagefromDB = async (item_id) => {
  const response_data = { status: 'false' };
  try {
    const response = await axios.get(`/quality-report/pallet-image/delete/${item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    });

    if (response.data.code === 200) {
      response_data.status = 'ok';
      return response_data;
    }
  } catch (error) {
    console.error("Error deleting the pallet image:", error);
    response_data.status = 'false';
  }

  return response_data;
};


  useEffect(() => {

    // axios
    // .post("/orders-quality-report/listing-shipped-delivered", {},  {
    //   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    // })
    // .then((response) => {
    //   if (response.data.code === 200) {
    //     let orders = response.data.data.orders;

    //     let orderlisting = orders.map((ord, index) => ({
    //       text: ord.po_number,
    //       id: ord.id,
    //       key: `order-${index}`,
    //     }));
    //    // setOrdersLists(orderlisting);
    //   } else {
    //     console.log("API response is not an array");
    //   }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  }, []);

  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  // const customHandleInput = (event) => {
  //   const Input_name = event.target.name;
  //   delete backendErrors[Input_name];

  // };
  // const deletepalletfromDB12 = (item_id) => {
  //   const  response_data = {};
  //   response_data.status = 'false';
  //   axios.get(`/quality-report/pallet/delete/${item_id}`, {
  //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //   }).then((response) => {
  //     if (response.data.code === 200) {
  //       response_data.status = 'ok';
  //       return response_data;
  //     }
  //   }).catch((error) => {
  //     response_data.status = 'false';
    
  //   });
  //   return response_data;
  // };
  const deletepalletfromDB = async (item_id) => {
    const response_data = { status: 'false' };
    // Show a confirmation alert
    const isConfirmed = window.confirm("Are you sure you want to delete this pallet?");
    if (!isConfirmed) {
      // If the user cancels the deletion, just return
      return response_data;
    }
    try {
      // Proceed with deletion if the user confirmed
      const response = await axios.get(`/quality-report/pallet/delete/${item_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) {
        response_data.status = 'ok';
        //alert("Pallet deleted successfully!"); // Show a success message after deletion
      } else {
        alert("Failed to delete the pallet. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting the pallet:", error);
      alert("Error occurred while deleting the pallet.");
    }
    return response_data;
  };

  // const handleImageClick = (imgIndex) => {
  //   setCurrentImageIndex(imgIndex);
  //   setShowCropper(true); // Show the cropper container when an image is clicked
  // };
  const [activePalletIndex, setActivePalletIndex] = useState(null);

  const handleImageClick = (palletIndex, imgIndex) => {
    setCurrentImageIndex(imgIndex);
    setActivePalletIndex(palletIndex); // Set the active pallet index to show the cropper for that pallet
    setShowCropper(true);
  };
  // const handleImageClick = (palletIndex, imgIndex) => {
  //   $(".image-contain").hide();
  //   $("#pallet-index-images-"+palletIndex).show();
    
  //   setCurrentImageIndex(imgIndex);
  //   setShowCropper(true);
  
  //   // Ensure the Cropper is focused on the image from the correct pallet and index
  //   const selectedImage = images[palletIndex] ? images[palletIndex][imgIndex] : null;
  //   if (selectedImage) {
  //     setImages((prev) => ({
  //       ...prev,
  //       [palletIndex]: prev[palletIndex],
  //     }));
  //   }
  // };


  const handleMoveImage = (palletIndex, imgIndex, direction) => {
    // Create a copy of the current pallet's images
    const updatedImages = [...images[palletIndex]];
  
    // Swap the current image with the one in the direction
    const swapIndex = imgIndex + direction;
    [updatedImages[imgIndex], updatedImages[swapIndex]] = [
      updatedImages[swapIndex],
      updatedImages[imgIndex],
    ];
  
    // Update the images state
    setImages((prev) => {
      const newImages = [...prev];
      newImages[palletIndex] = updatedImages;
      return newImages;
    });
  
    // Update Formik state
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);
  };
  

  console.log(images);
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />  <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Quality Report</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/quality-reports">Quality Report</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit  Quality Report</li>
                </ul>
              </div>
            </div>
          </div>
          {permission && permission.add === 1 && (

          <FormikProvider value={formik}>
            <form action="#" onSubmit={formik.handleSubmit}>
              {/* Additional fields and pallets */}
              <div className="row">
              <div className="col-md-12">
              <h2 style={{color:"#1B2E6B"}}>Details: </h2> 
                     <table className="table table-bordered">
                       <tr>
                         <td className="p-3">Sender</td>
                         <th className="p-3">{value.sender}</th>
                         <td className="p-3">Customer</td>
                         <th className="p-3">{value.customer}</th>
                       </tr>
                       <tr>
                         <td className="p-3">Ref</td>
                         <th className="p-3">{value.ref}</th>
                         <td className="p-3">PO Number</td>
                         <th className="p-3"> {value.order ? value.order_detail.po_number : ""}</th>
                       </tr>
                       <tr>
                         <td className="p-3">Product</td>
                         <th className="p-3">{value.product}</th>
                         <td className="p-3">Transport</td>
                         <th className="p-3">{value.transport}</th>
                       </tr>
                       <tr>
                         <td className="p-3">Date</td>
                         <th className="p-3">{value.date}</th>
                         <td className="p-3">Transpor Number</td>
                         <th className="p-3">{value.transport_number}</th>
                       </tr>
                  </table>
               </div>
               </div>

              <div className="row">
                <div className="col-md-6">
                  <h4 className="card-title">
                    <br />
                    Items
                  </h4>
                </div>
              </div>

              <FieldArray
                name="pallets"
                render={(arrayHelpers) => (
                  <div>
                    <button
                      className="btn btn-primary mb-3"
                      type="button"
                      onClick={() => {
                        //let appendArr = arrayHelpers.form.values.pallets[0];
                        let initialArr = {
                          product: "",
                          temperature: "",
                          size: "",
                          sample_weight: "",
                          class: "",
                          box_net_weight: "",

                          packaging: "",
                          lot_number: "",
                          number_of_boxes: "",
                          palletesation: "",
                          country: "",
                          label_conformity: "",
                          pictures:[]
                        };
                       // appendArr = appendArr ? appendArr : initialArr;
                        arrayHelpers.push(initialArr);
                        //setShowTableHeadings(true);
                      }}
                    >
                      +
                    </button>
                    {formik.values.pallets.map((item, palletIndex) => (
                      <div key={palletIndex}>
                        <div className="row">
                          <div className="col-md-12" style={{fontSize:'20px'}}>Pallet# {palletIndex + 1}</div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Product/Variety </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].product`}
                                value={formik.values.pallets[palletIndex].product}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Temperature ° </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].temperature`}
                                value={
                                  formik.values.pallets[palletIndex].temperature
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Size </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].size`}
                                value={formik.values.pallets[palletIndex].size}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Sample weight (g) </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].sample_weight`}
                                value={
                                  formik.values.pallets[palletIndex].sample_weight
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Class </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].class`}
                                value={formik.values.pallets[palletIndex].class}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Box net weight (g) </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].box_net_weight`}
                                value={
                                  formik.values.pallets[palletIndex].box_net_weight
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Packaging </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].packaging`}
                                value={formik.values.pallets[palletIndex].packaging}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Lot number </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].lot_number`}
                                value={formik.values.pallets[palletIndex].lot_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Number of boxes </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].number_of_boxes`}
                                value={
                                  formik.values.pallets[palletIndex].number_of_boxes
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Palletesation </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].palletesation`}
                                value={
                                  formik.values.pallets[palletIndex].palletesation
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Enter Country of origin </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].country`}
                                value={formik.values.pallets[palletIndex].country}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group status">
                              <label>Enter Label conformity </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].label_conformity`}
                                value={
                                  formik.values.pallets[palletIndex].label_conformity
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className="col-md-11">
                          <DropzoneComponent
                          palletIndex={palletIndex}
                          onDrop={onDrop} // Pass onDrop as a prop
                        />
                    

                            
<div
  style={{
    display: "flex",
    marginTop: "20px",
    flexWrap: "wrap",
  }}
>
  {images[palletIndex]?.map((image, imgIndex) => (
    <div
      key={imgIndex}
      style={{
        position: "relative",
        margin: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        src={image}
        alt={`preview ${imgIndex}`}
        style={{
          width: "150px",
          cursor: "pointer",
          border: currentImageIndex === imgIndex ? "2px solid blue" : "none",
        }}
        onClick={() => handleImageClick(palletIndex, imgIndex)}
      />
      <div style={{ marginTop: "5px" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={imgIndex === 0} // Disable "Move Up" for the first image
          onClick={() => handleMoveImage(palletIndex, imgIndex, -1)}
          style={{ marginRight: "5px" }}
        >
          Up
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={imgIndex === images[palletIndex].length - 1} // Disable "Move Down" for the last image
          onClick={() => handleMoveImage(palletIndex, imgIndex, 1)}
        >
          Down
        </Button>
      </div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => handleDeleteImage(palletIndex, imgIndex)}
        style={{
          marginTop: "5px",
          backgroundColor: "red",
          color: "white",
          fontSize: "10px",
        }}
      >
        x
      </Button>
    </div>
  ))}
</div>
                                                    
    {images[palletIndex]?.length > 0 && (
      <Dialog
        open={showCropper && activePalletIndex === palletIndex}
        onClose={() => setShowCropper(false)} // Close the popup
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Image Editor</DialogTitle>
        <DialogContent>
          <div
            style={{
              position: "relative",
              height: "400px",
              width: "100%",
            }}
          >
            <Cropper
              image={images[palletIndex][currentImageIndex]}
              crop={crop}
              zoom={zoom}
              aspect={1}
              rotation={rotation}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          <div>
            <h4>Rotation</h4>
            <Slider
              value={rotation}
              onChange={(e, newValue) => setRotation(newValue)}
              min={0}
              max={360}
            />
          </div>

          <div>
            <h4>Zoom</h4>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              onChange={(e, newZoom) => setZoom(newZoom)}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleSaveCroppedImage(palletIndex, currentImageIndex);
              setShowCropper(false); // Close the popup after saving
            }}
          >
            Save Cropped Image
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setShowCropper(false)} // Close the popup without saving
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )}

                        
                          </div>
                          <div className="col-md-1">
                            <button
                              className="btn btn-danger"
                              // style={{ marginTop: 30 }}
                              type="button"
                             // onClick={() => arrayHelpers.remove(palletIndex)}
                             // onClick={() => {  arrayHelpers.remove(palletIndex)  }}
                              onClick={() =>{
                                let item_record = formik.values.pallets[palletIndex];
                                if(item_record.id == undefined){
                                  arrayHelpers.remove(palletIndex)
                                }else{
                                  deletepalletfromDB(item_record.id);
                                  arrayHelpers.remove(palletIndex)
                                }
                              } }
                            >
                              -
                            </button>
                            {palletIndex === formik.values.pallets.length - 1 && (
                              <div>
              <button  
                          className="btn btn-primary mb-3"
                          type="button"
                          //style={{paddingTop:'30px;'}}
                          onClick={() => {
                          //  let appendArr = arrayHelpers.form.values.pallets[0];
                            let appendArr_1 = arrayHelpers.form.values.pallets && arrayHelpers.form.values.pallets[0];

                            let product_name = (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "";
                            let temperature_name = (appendArr_1 && appendArr_1.temperature) ? appendArr_1.temperature : "";
                            let size_name = (appendArr_1 && appendArr_1.size) ? appendArr_1.size : "";
                            let sample_weight_name = (appendArr_1 && appendArr_1.sample_weight) ? appendArr_1.sample_weight : "";
                            let class_name = (appendArr_1 && appendArr_1.class) ? appendArr_1.class : "";
                            let box_net_weight_name = (appendArr_1 && appendArr_1.box_net_weight) ? appendArr_1.box_net_weight : "";
                            
                            let packaging_name = (appendArr_1 && appendArr_1.packaging) ? appendArr_1.packaging : "";
                            let lot_number_name = (appendArr_1 && appendArr_1.lot_number) ? appendArr_1.lot_number : "";
                            let number_of_boxes_name = (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "";
                            let palletesation_name = (appendArr_1 && appendArr_1.palletesation) ? appendArr_1.palletesation : "";
                            let country_name = (appendArr_1 && appendArr_1.country) ? appendArr_1.country : "";
                            let label_conformity_name = (appendArr_1 && appendArr_1.label_conformity) ? appendArr_1.label_conformity : "";
                                          
                            let initialArr = {
                              product:product_name,
                              temperature: temperature_name,
                              size: size_name,
                              sample_weight: sample_weight_name,
                              class: class_name,
                              box_net_weight: box_net_weight_name,

                              packaging: packaging_name,
                              lot_number: lot_number_name,
                              number_of_boxes: number_of_boxes_name,
                              palletesation: palletesation_name,
                              country: country_name,
                              label_conformity: label_conformity_name,
                              pictures:[]
                            };
                            // appendArr = appendArr ? appendArr : initialArr;
                            arrayHelpers.push(initialArr);
                            //setShowTableHeadings(true);
                          }}
                          >
                          +
                          </button>
                              </div>
                          
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              />
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  Add Pallets
                </button>
              </div>
            </form>
          </FormikProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default QualityReportsAddPallet;
